import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  SetLocalStorageStringify,
  stringifyData,
} from "../utils/page";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import "../page.module.css";
import moment from "moment";
import { BsBellFill } from "react-icons/bs";
import { ClipLoader } from "react-spinners";
import Header from "../../Components/Header/Header";
import BannerPage from "../../Components/Banner/BannerPage";
import ProductArea from "../../Components/ProductArea/ProductArea";
import OtherAffiliatePartner from "../../Components/OtherAffiliatePartner/OtherAffiliatePartner";
import SavedBannerComponent from "../../Components/SavedBanner/SavedBannerComponent";
import TopAffiliatePartner from "../../Components/TopAffiliatePartner/TopAffiliatePartner";
import OurExclusivePartner from "../../Components/OurExclusivePartner/OurExclusivePartner";
import TopWinners from "../../Components/TopWinners/TopWinners";
import LoginModal from "../../Components/LoginModal/LoginModal";
import Footer from "../../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import "./Home.css";
import BottomFooter from "../../Components/BottomFooter/BottomFooter";
import LandingPageComponent from "../../Components/LandingPageComponent/LandingPageComponent";

export default function Home() {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const FetchModalTime = GetLocalStorageParsed("ShowModal");
  const [afterLoginToken, setAfterLoginToken] = useState();

  const [promotionalBanner, setPromotionalBanner] = useState();
  const [upprBanner, setUpperBanner] = useState();

  const [lowerBanner, setLowerBanner] = useState();
  const [showCaseBanners, setShowCaseBanners] = useState();
  const [leftMidBanner, setLeftMidBanner] = useState();

  const [rightMidBanner, setRightMidBanner] = useState();

  const router = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [categoriesData, setcategoriesData] = useState();
  const [bidAndDealProducts, setBidAndDealProducts] = useState();

 

  const handleGetCategory = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetCategoriesFromProduct`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setcategoriesData(data);
      })
      .catch((error) => {});
  };
  const handleGetExpiringBidsAndBestDealsProducts = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetExpiringBidsAndBestDealsProducts`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setBidAndDealProducts(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  const GetRewardList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/GetAvailableRewards`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const dataformat = data?.map((item) => ({
          ...item,
          selectedQuantity: 0,
        }));
        setRewardList(dataformat);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    handleGetCategory();
    handleGetExpiringBidsAndBestDealsProducts();
    GetRewardList();
  }, []);

  // Function to safely get and parse the cookie data

  const [isMobileScreen, setIsMobileScreen] = useState(false);

  const [loading, setLoading] = useState("");
  const [apiCallingOnLogin, setApiCallingOnLogin] = useState(false);
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [showReward, setShowReward] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [rewardList, setRewardList] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState("");
  const [showEventModal, setShowEventModal] = useState(false);
  const [showLoginTrue, setShowLoginTrue] = useState();
  const [bannerIdData, setBannerIdData] = useState();

  // const handleCloseEvent = () => {
  //   const now = new Date();
  //   const futureTime = new Date(now.getTime() + 12 * 60 * 60 * 1000); // 12 hours in the future
  //   SetLocalStorageStringify("ShowModal", futureTime.toISOString());
  //   setShowEventModal(false);
  // };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth >= 320 && window.innerWidth <= 767);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // get banner

  // get all product

  // login modal show and close
  const handleShow = () => {
    setShowLoginModal(true);
  };
  const handleClose = () => {
    setShowLoginModal(false);
  };
  // get profile
  const getProfile = (token) => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token || loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/UserInfo`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setProfileData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  // login api
  const loginApi = (userDetail) => {
    const data = {};
    data.email = userDetail?.email;
    data.name = userDetail?.name;
    data.image = userDetail?.picture;
    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/Login`,
    };
    axios(options)
      .then((data) => {
        const token = parseData(data?.data?.result);
        const user = jwtDecode(token?.Token);
        SetLocalStorageStringify("UserDetail", JSON.stringify(token));
        SetLocalStorageStringify("User", JSON.stringify(user));
        SetLocalStorageStringify("AuthToken", token?.Token);
        setShowLoginTrue(token?.Token);

        setAfterLoginToken(token?.Token);
        getProfile(token?.Token);

        handleClose();
      })
      .catch((error) => {});
  };

  const handleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => {
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        { headers: { Authorization: `Bearer ${access_token}` } }
      );

      loginApi(userInfo?.data);
      // SetLocalStorageStringify("googleData", userInfo?.data)
    },
  });

  useEffect(() => {
    if (loginToken) {
      getProfile();
    }
  }, [loginToken]);
  const GetPromotionalBanner = () => {
    setLoading("banner");
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Customer/GetPromotionalBanners`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        if (Array.isArray(data?.SideBanners)) {
          const banners = data.SideBanners;
          const mid = Math.ceil(banners.length / 2);

          const upper = banners.slice(0, mid);
          const lower = banners.slice(mid);

          setUpperBanner(upper);
          setLowerBanner(lower);
        }
        if (Array.isArray(data?.MidSectionBanners)) {
          const banners = data.MidSectionBanners;
          const mid = Math.ceil(banners.length / 2);

          const upper = banners.slice(0, mid);
          const lower = banners.slice(mid);

          setLeftMidBanner(upper);
          setRightMidBanner(lower);
        }

        setPromotionalBanner(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const GetShowCaseBanners = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Customer/GetShowCaseBanners`,
    };
    axios(option)
      .then((e) => {
        setShowCaseBanners(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };

  useEffect(() => {
    GetPromotionalBanner();
    GetShowCaseBanners();
  }, []);

  //  get extra points
  const handleGetExtraPoints = (item) => {
    setLoading("getPoint");
    const data = {
      ExtraPoints: null,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/AddExtraPoints`,
    };
    axios(option)
      .then((e) => {
        getProfile();
      })
      .catch((error) => {});
  };
 
 
  useEffect(() => {
    if (timeLeft <= 0 && loginToken) {
      getProfile();
    }
  }, [timeLeft]);

  useEffect(() => {
    if (profileData?.TimeLeftToGetLuckyPoints) {
      // Calculate the end time once when the effect is first run
      const timeString = profileData?.TimeLeftToGetLuckyPoints || "00:00:00";
      const timeParts = timeString.split(":");

      const endTime = moment()
        .add(parseInt(timeParts[0], 10), "hours")
        .add(parseInt(timeParts[1], 10), "minutes")
        .add(parseInt(timeParts[2], 10), "seconds");

      const calculateTimeLeft = () => {
        const now = moment(); // Current time
        const timeDifference = endTime.diff(now); // Calculate difference from the stored endTime

        if (timeDifference <= 0) {
          setTimeLeft("");
          clearInterval(timer); // Stop the timer if expired
        } else {
          const duration = moment.duration(timeDifference);
          const hours = Math.floor(duration.asHours());
          const minutes = duration.minutes();
          const seconds = duration.seconds();
          setTimeLeft(`${hours}H : ${minutes}M : ${seconds}S`);
        }
      };
      const timer = setInterval(calculateTimeLeft, 1000); // Update every second
      // Cleanup interval when component unmounts or profileData changes
      return () => clearInterval(timer);
    }
  }, [profileData]);
  // get reward list

  // useEffect(() => {
  //   const FetchModalTime = JSON.parse(localStorage.getItem("ShowModal")); // Fetch from localStorage
  //   const now = new Date();

  //   // Check if the current time surpasses the saved time
  //   if (!FetchModalTime || now > new Date(FetchModalTime)) {
  //     setShowEventModal(true); // Show modal if the time has surpassed or not set
  //   }
  // }, []);
 
  return (
    <>
      {loading === "mainLoader" ||
      loading === "homePage" ||
      loading == "banner" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <>
        <Header
          apiCallingOnLogin={apiCallingOnLogin}
          setLoginToken={setLoginToken}
          setApiCallingOnLogin={setApiCallingOnLogin}
          profileData={profileData}
          setLoading={setLoading}
          loading={loading}
          showLoginTrue={showLoginTrue}
          afterLoginToken={afterLoginToken}
        />

        <LandingPageComponent
          categoriesData={categoriesData}
          bidAndDealProducts={bidAndDealProducts}
          loading={loading}
          setLoading={setLoading}
          setBannerIdData={setBannerIdData}
          bannerIdData={bannerIdData}
          promotionalBanner={promotionalBanner}
          showCaseBanners={showCaseBanners}
          upprBanner={upprBanner}
          lowerBanner={lowerBanner}
          leftMidBanner={leftMidBanner}
          rightMidBanner={rightMidBanner}
        />

        {/* <BannerPage
          bannerData={bannerData}
          loading={loading}
        />
        <ProductArea
          loading={loading}
          filteredProductData={filteredProductData}
          setIndexForProducts={setIndexForProducts}
          indexForProduct={indexForProduct}
          handleBuyProduct={handleBuyProduct}
          onNextClick={onNextClick}
          smallBannerData={smallBannerData}
          handleAddtoFavourite={handleAddtoFavourite}
          favouriteData={favouriteData}
          bannerIdData={bannerIdData}
          hanleDeleteFavourite={hanleDeleteFavourite}
          loginToken={loginToken}
        />
        <OtherAffiliatePartner
          allProductsData={allProductsData}
          totalRecordAffiliate={totalRecordAffiliate}
          getAllProducts={getAllProducts}
          pageNumberAffiliate={pageNumberAffiliate}
        /> */}
        {/* favorite section */}
        {/* {favouriteData?.length ?
            <SavedBannerComponent favouriteData={favouriteData} hanleDeleteFavourite={hanleDeleteFavourite} />
            : null
          } */}
        {/* <TopAffiliatePartner /> */}
        {/* <OurExclusivePartner handleShow={handleShow}/> */}
        {/* <TopWinners /> */}
        <LoginModal
          showLoginModal={showLoginModal}
          setShowLoginModal={setShowLoginModal}
          handleClose={handleClose}
          handleLogin={handleLogin}
        />
        {/* get points div */}
        {loginToken ? (
          <>
            <div className="container">
              <div className="click_me_section ">
                <div className="row">
                  <div className="col-lg-9 col-12 mb_padding_0">
                    {profileData?.IsUserWinExtraPointsToday === false ? (
                      loading === "getPoint" ? (
                        <button
                          type="button"
                          className="click_me_btn"
                          data-bs-toggle="collapse"
                        >
                          <ClipLoader loading size={15} />
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="click_me_btn"
                          data-bs-toggle="collapse"
                          onClick={handleGetExtraPoints}
                        >
                          Get Points
                        </button>
                      )
                    ) : (
                      <button
                        type="button"
                        className="click_me_btn"
                        data-bs-toggle="collapse"
                        onClick={() =>
                          toast.error(
                            `You already claimed points. Please try again after ${timeLeft}`
                          )
                        }
                      >
                        Get Points In
                        <span>{timeLeft}</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
        {/* <button type="button" className="offer_btn" data-bs-toggle="collapse" onClick={() => router('/FestivalProducts')}>
          New Year Bonanza</button> */}

        {/* reward section */}
        {rewardList?.length && loginToken ? (
          <div
            className="floating_notify pulse_notify_animation"
            onClick={() => setShowReward(!showReward)}
          >
            <button className="openChatBtn modal_button_ic color">
              <BsBellFill />
            </button>
            {showReward ? (
              <div className="openChat">
                <div className="claim_popup_list">
                  <div className="claim_rwd_popup_head">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2 className="common_heading">Rewards List </h2>
                        <p
                          className="popup_prode_close_btn close mb-0"
                          onClick={() => setShowReward(false)}
                        >
                          ×
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="claim_offer_content ">
                    <div className="claim_reward_item_scroll">
                      <div className="row">
                        {rewardList?.map((item) => {
                          const img = item?.RewardImage.split('"');
                          const imgUrl = `${Apiurl()}/${img?.[1]}`;
                          return (
                            <>
                              <div className="col-lg-3 col-3">
                                <img
                                  className="reward_img"
                                  src={imgUrl}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/Images/no-product-img-700.jpg";
                                  }}
                                />
                              </div>
                              <div className="col-lg-9 col-9">
                                <h3>{item?.RewardName}</h3>
                                <p>
                                  End Date:
                                  {moment(item?.EndDate).format("DD-MM-YYYY")}
                                </p>
                              </div>
                              <div className="col-lg-12">
                                <hr className="rew-btm_border" />
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <button
                        type="button"
                        className="common_btn claim_rew_pd w-100"
                        onClick={() => {
                          if (loginToken || showLoginTrue) {
                            router("/referralsprogram");
                          } else {
                            handleShow();
                          }
                        }}
                      >
                        Get Rewards
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {/* event modal */}
        {/* <Modal backdrop="static" className="event_modal" show={showEventModal} onHide={handleCloseEvent} animation={false}>

          <div className='event_div' style={{ cursor: "pointer" }}>
            <IoClose className='cross_butt_event' onClick={handleCloseEvent} />
            <img className="image_event_div" src="https://cloudapi.shopsaverz.com/Images/Event/e3921baf-144b-4dc6-bb97-206a8a7e19bc/e01aced2-1fca-412c-b122-6f64400d97da.jpg" alt="" onClick={() => router('/FestivalProducts')} />
          </div>




        </Modal> */}
        <Footer />
        {/* {isMobileScreen && <BottomFooter />} */}
      </>
    </>
  );
}
